import { Element } from 'react-scroll';

import { getFormattedAnchor } from '@/components/blocks/StickySubnav';

import type { StickySubnavAnchor as StickySubnavAnchorType } from '@/sanity/sanity.types';

export interface StickySubnavAnchorProps extends StickySubnavAnchorType {}

export const StickySubnavAnchor = ({
  stickySubnavAnchorData,
}: StickySubnavAnchorProps) => {
  const name = getFormattedAnchor(stickySubnavAnchorData);

  return <Element name={name} id={name} aria-hidden="true" />;
};
